export default {
  id: 'gruas-alfa',
  displayName: 'Gruas Alfa',
  topbarColor: '#000000',
  topbarLogo: require('@/assets/logoalfa.png'),
}
